import type { ItemCriteria } from "./response";

export type GradingSelectionExpectedResponse = {
	choiceId: string;
	points: number;
	explanation?: string;
};

export type AnswerKeySelection = {
	selection?: {
		min: number;
		max: number;
	};
	answerKey: {
		choiceId: string;
		isCorrect: boolean;
		points: number;
	}[];
	points?: number;
};

export type GradingFormExpectedResponse = {
	fieldId: string;
	response: string;
	points: number;
};

export type GradingCriteriaItem = Omit<ItemCriteria, "icon">;

export type GradingItemPoints = {
	id: string;
	points: number;
};

export type GradingCriterionPoints = {
	id: string;
	points: number;
};

export type Grading = (
	| {
			type: "AI_RUBRIC";
			criteria: Record<string, ItemCriteria>;
			points?: number;
	  }
	| {
			type: "ANSWER_KEY_MAPPING";
			answerKey: {
				blankId: string;
				wordId: string;
				points: number;
			}[];
			points?: number;
	  }
	| {
			type: "ANSWER_KEY_TEXT";
			answerKey: {
				blankId: string;
				word: string;
				points: number;
			}[];
			points?: number;
	  }
	| {
			type: "ANSWER_KEY_ORDERING";
			correctOrder: number[];
			points?: number;
	  }
	| {
			type: "ANSWER_KEY_ACCEPTED_RESPONSE";
			acceptedAnswers: string[];
			criteria?: Record<string, ItemCriteria>;
			points?: number;
	  }
	| ({
			type: "ANSWER_KEY_SELECTION";
	  } & AnswerKeySelection)
	| ({
			type: "choice";
	  } & AnswerKeySelection)
	| {
			type: "binary";
			points?: number;
	  }
	| {
			type: "selection";
			points?: { min: number; max: number };
			expectedResponses: GradingSelectionExpectedResponse[];
	  }
	| {
			type: "form";
			points?: { min: number; max: number };
			expectedResponses: GradingFormExpectedResponse[];
	  }
	| {
			type: "criteria";
			criteria: Record<string, { maxPoints: number; [key: string]: unknown }>;
	  }
	| {
			type: "points";
			totalPoints: number;
	  }
	| {
			type?: undefined;
			maximumScore?: number;
	  }
) & {
	criteria?: Record<string, ItemCriteria>;
};
